import React from "react";

import styled from "styled-components";

import { Dimensions } from "../Dimensions";

import type { GridProps } from "./Grid.types";
import { generateGridColumnStyles, generateGridGapStyles } from "./Grid.utils";

const StyledGrid = styled.div<GridProps>`
    display: grid;
    grid-auto-flow: ${({ autoFlow }) => autoFlow};
    grid-auto-rows: ${({ autoRows }) => autoRows};
    grid-auto-columns: ${({ autoColumns }) => autoColumns};
    align-items: ${({ alignItems }) => alignItems};
    justify-items: ${({ justifyItems }) => justifyItems};
    place-content: ${({ placeContent }) => placeContent};

    ${({ columns }) => generateGridColumnStyles(columns!)};
    ${({ gap, rowGap, columnGap }) => generateGridGapStyles(gap!, rowGap, columnGap)};
`;

export const Grid: React.FC<React.PropsWithChildren<GridProps>> = ({
    columns = 1,
    gap = Dimensions.d16,
    rowGap = gap,
    columnGap = gap,
    autoFlow = "row",
    autoRows = "1fr",
    autoColumns = "auto",
    children,
    ...restProps
}) => {
    return (
        <StyledGrid
            columns={columns}
            gap={gap}
            rowGap={rowGap}
            columnGap={columnGap}
            autoFlow={autoFlow}
            autoRows={autoRows}
            autoColumns={autoColumns}
            {...restProps}
        >
            {children}
        </StyledGrid>
    );
};
